import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  additionalClassName: PropTypes.string,
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  bonusSpots: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

function BagBannerComponent({ additionalClassName, headerText, subHeader, bonusSpots }) {
  const bannerTestId = additionalClassName ? "upgrade-banner-sub-header" : "bag-banner-sub-header";

  return (
    <div className={`banner ${additionalClassName ? additionalClassName : ""}`} data-test-id="bag-banner">
      <h2 className="header" data-test-id="banner-header">
        {headerText}
      </h2>
      <div className="universal-medium sub-header" data-test-id={bannerTestId}>
        {subHeader}
      </div>
      {bonusSpots && (
        <div
          className="text-tealGreen font-bold text-base bg-transparent p-0 flex items-end universal-medium"
          data-test-id="banner-bonus-spots">
          {bonusSpots}
        </div>
      )}
    </div>
  );
}

BagBannerComponent.propTypes = propTypes;

export default BagBannerComponent;
